/**
 * App environment sent with outbound browser calls so /voice can route
 * callbacks (e.g. callComplete) to dev vs prod incoming handlers.
 */
export function getAppEnvironment() {
  const explicit = process.env.REACT_APP_ENV?.trim().toLowerCase();
  if (explicit) {
    return explicit;
  }

  const backendUrl = (process.env.REACT_APP_BACKEND_URL || "").toLowerCase();
  if (
    backendUrl.includes("dev.backend") ||
    backendUrl.includes("localhost") ||
    backendUrl.includes("127.0.0.1")
  ) {
    return "dev";
  }

  return "prod";
}
